import { showLoader, hideLoader } from '../../actions/shared/loader';
import { setErrorObject } from '../../actions/shared/HTTPError';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  tokenReCreateParser
} from '../../modules/ajio-fetch/utils';
import { readCookie } from '../../components/common/Cookie';
import { showModal } from '../../actions/modal.js';
import { fetchProducts } from '../../actions/shared/productsData';

import { getWishlistAPIResponseMessage } from '../../utils/handleWishlistMessages';
import wishlistStatusCodes from '../../utils/wishlistStatusCodes';
import { signInCheck } from '../../components/common/CheckUserStatus';
import { deleteBulkOosItems, deleteCard } from '../../cart/actions/cart';

function addedToWishlist(showWishlist, status) {
  return {
    type: 'SHOW_WISHLIST_POPUP',
    showWishlistPopup: showWishlist,
    wishlistStatus: status
  };
}

function removeFromWishlist(showWishlist, status) {
  return {
    type: 'SHOW_WISHLIST_POPUP',
    showWishlistPopup: showWishlist,
    wishlistStatus: status,
    isProductRemoved: true
  };
}

function wishlistData(response) {
  return {
    type: 'WISHLIST_DATA',
    response
  };
}

export function addProductToWishlist(
  data,
  showMessage = true,
  isRecursiveCalling = false,
  requestedDeviceType = 'desktop'
) {
  const { ITEM_ADDED_TO_WISHLIST = '', ITEM_DELISTED_FROM_SITE = '' } = wishlistStatusCodes;
  return function(dispatch) {
    dispatch(showLoader('products-loader'));
    const apiEndPoint = `/api/wishlist/addProductToWishlist`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify({ productCodePost: data, isCloset: true }),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { statusCode = '' } = response;
        dispatch(hideLoader('products-loader'));
        // Fix for DCFL-45884.
        // Whenever status code 1 or 2  is returned from API
        // it is not handled on frontend
        if (statusCode > ITEM_ADDED_TO_WISHLIST && statusCode <= ITEM_DELISTED_FROM_SITE) {
          let message = '';

          message = getWishlistAPIResponseMessage(response, null, requestedDeviceType);
          const messageBar = {
            errorType: 'info',
            message
          };
          if (showMessage) dispatch(setErrorObject(messageBar));
          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
        } else if (statusCode === ITEM_ADDED_TO_WISHLIST) {
          dispatch(addedToWishlist(true, statusCode));
          const timeout = setTimeout(() => {
            dispatch(addedToWishlist(false, statusCode));
            clearTimeout(timeout);
          }, 5000);
        }
        return Promise.resolve(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        if (statusCode === 401 && !isRecursiveCalling) {
          return tokenReCreateParser(statusCode).then(() => {
            return addProductToWishlist(data, showMessage, true)(dispatch);
          });
        }
        dispatch(addedToWishlist(true, statusCode));
        const wishlist_timeout = setTimeout(() => {
          dispatch(addedToWishlist(false, '2'));
          clearTimeout(wishlist_timeout);
        }, 5000);
        dispatch(setErrorObject(error));
        dispatch(hideLoader('products-loader'));
        const timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);

        return Promise.reject(error);
      });
  };
}

export function removeProductFromWishlist({ data, request }) {
  return function(dispatch) {
    dispatch(showLoader('products-loader'));
    const apiEndPoint = `/api/wishlist/removefromwishlist/${data}`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { statusCode = 0 } = response;
        let message = 'Removed from wishlist';
        if (statusCode !== 0) {
          message = 'Oops! something went wrong, Please try again';
        }
        const messageBar = {
          errorType: 'info',
          message
        };
        dispatch(fetchProducts({ request, isRequestOrginIsBrowser: true })).then(() => {
          dispatch(setErrorObject(messageBar));
          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
          dispatch(removeFromWishlist(true, 5));
          const timeoutPopup = setTimeout(() => {
            dispatch(removeFromWishlist(false, 5));
            clearTimeout(timeoutPopup);
          }, 5000);
        });
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        if (statusCode === 401) {
          tokenReCreateParser(statusCode).then(() => {
            removeProductFromWishlist({ data, request })(dispatch);
          });
        } else {
          dispatch(setErrorObject(error));
          dispatch(hideLoader('products-loader'));
          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
        }
      });
  };
}

export function removeProductFromWishlistPDP({ data, request }) {
  return function(dispatch) {
    const apiEndPoint = `/api/wishlist/removefromwishlist/${data}`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { statusCode = 0 } = response;
        let message = 'The product is removed from your wishlist';
        if (statusCode !== 0) {
          message = 'Oops! something went wrong, Please try again';
        }
        const messageBar = {
          errorType: 'info',
          message
        };
        dispatch(setErrorObject(messageBar));
        const timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);
        // set message for remove items from wishlist in search and category page
        dispatch(removeFromWishlist(true, 5));
        const timeoutPopup = setTimeout(() => {
          dispatch(removeFromWishlist(false, 5));
          clearTimeout(timeoutPopup);
        }, 5000);
      })
      .catch(error => {
        dispatch(setErrorObject(error));
        const timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);
      });
  };
}

export function getProductFromWishlist() {
  return function(dispatch) {
    if (readCookie('U') === 'anonymous') {
      return;
    }
    dispatch(showLoader('products-loader'));
    const apiEndPoint = `/api/wishlist/getwishlist`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        headers: {
          Accept: 'application/json',
          credentials: 'include',
          'cache-control': 'no-store, no-cache, must-revalidate',
          Expires: 'Thu, 01 Jan 1970 00:00:00 GMT'
        }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('products-loader'));
        dispatch(wishlistData(response));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        // DCFL-46928 :  removed token parser code
        // it was causing the empty cart to redirect to homepage
        dispatch(hideLoader('products-loader'));
        if (statusCode !== 401) {
          dispatch(setErrorObject(error));
          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
        }
      });
  };
}
export function openSizeModal(variantOptions, sizeDisplayType) {
  return function(dispatch) {
    dispatch(
      showModal('cart-size-modal', {
        state: { product: variantOptions, sizeDisplayType }
      })
    );
  };
}

export function showWishlistDialog() {
  return {
    type: 'SHOW_WISHLIST_DIALOG_MSITE',
    visibility: true
  };
}

export function hideWishlistDialog() {
  return {
    type: 'HIDE_WISHLIST_DIALOG_MSITE',
    visibility: false
  };
}

export function loadWishlistOptionCodesAPI() {
  const apiEndPoint = `/api/wishlist/getOptionCodes`;
  return fetcher(
    apiEndPoint,
    fetchGetJSONReqOpts({
      method: 'GET',
      headers: { 'content-type': 'application/json' }
    })
  )
    .then(fetchGetJSONResHandler)
    .then(response => {
      if (response?.optionsCode) {
        const username = signInCheck(true);
        if (!username) return Promise.resolve(true);
        let finalResponse = {};
        const localData = {
          updatedOn: Date.now(),
          codes: response.optionsCode
        };
        const wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
        if (wishlistData) finalResponse = wishlistData;
        finalResponse[username] = localData;
        localStorage.setItem('productWishlistStatusData', JSON.stringify(finalResponse));
      }
      return Promise.resolve(true);
    })
    .catch(err => {
      console.log('🚀 ~ file: wishlist.js ~ line 219 ~ loadWishlistOptionCodesAPI ~ err', err);
      return Promise.resolve(false);
    });
}

export const setWishlistNotify = (notifyValue) => {
  return function(dispatch){
    const message = "Get ready! We'll notify vai registered email"
    const messageBar = {
      errorType: 'info',
      message
    } 
    dispatch(setErrorObject(messageBar));
    const timeout = setTimeout(() => {
      dispatch(setErrorObject({}));
      clearTimeout(timeout);
    }, 5000);
  };
};


export function bulkMoveToWishlist(
  data,
  callback,
  isRecursiveCalling = false,
  requestedDeviceType = 'msite',
  showMessage = true
) {
  const { ITEM_ADDED_TO_WISHLIST = '', ITEM_DELISTED_FROM_SITE = '', ITEM_ALREADY_EXIST_IN_WISHLIST } = wishlistStatusCodes;
  return function(dispatch) {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = `/api/wishlist/bulkMoveToWishlist`;
    const {oosItemsId, oosSkuIds, guid} = data;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify({ optionsCodes: oosItemsId, tenantId: 'AJIO', sourceStoreId:'AJIO' }),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { statusCode = '', successOptionsCode =[] } = response;
        if (statusCode > ITEM_ADDED_TO_WISHLIST && statusCode <= ITEM_DELISTED_FROM_SITE && statusCode != ITEM_ALREADY_EXIST_IN_WISHLIST) {
          let message = '';
          const messageBar = {
            errorType: 'info',
            message: 'Oops something went wrong! Please try again'
          };
          if (showMessage) dispatch(setErrorObject(messageBar));
          dispatch(hideLoader('cart-loader'));
          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
        } else if (statusCode === ITEM_ADDED_TO_WISHLIST) {
          dispatch(addedToWishlist(true, statusCode));
          const timeout = setTimeout(() => {
            dispatch(addedToWishlist(false, statusCode));
            dispatch(deleteBulkOosItems({skus: oosSkuIds, guid, isFromWishList: true},callback))
            clearTimeout(timeout);
          }, 5000);
        }
        return Promise.resolve(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        if (statusCode === 401 && !isRecursiveCalling) {
          return tokenReCreateParser(statusCode).then(() => {
            return bulkMoveToWishlist(data, callback, true)(dispatch);
          });
        }
        dispatch(addedToWishlist(true, statusCode));
        const wishlist_timeout = setTimeout(() => {
          dispatch(addedToWishlist(false, '2'));
          clearTimeout(wishlist_timeout);
        }, 5000);
        const messageBar = {
          errorType: 'info',
          message: 'Oops something went wrong! Please try again'
        };
        dispatch(setErrorObject(messageBar));
        dispatch(hideLoader('cart-loader'));
        const timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);

        return Promise.reject(error);
      });
  };
}

export function moveAllIneligibleItemToCloset(callback) {
  return async (dispatch, getState) => {
    dispatch(showLoader('cart-loader'));
    const { cartItem } = getState();
    const items = cartItem.filter(x => x.isGstEligible);
    const promiseArray = [];
    try {
      const entryNumbers = [];
      for (let i = 0; i < items.length; i++) {
        const addToWishList = dispatch(addProductToWishlist(items[i].code, false));
        const deleteCartItem = dispatch(
          deleteCard({ entryNumber: items[i].entryNumber, refreshCartItem: true }, false, false)
        );
        promiseArray.push(addToWishList);
        entryNumbers.push(deleteCartItem);
        // entryNumbers.push(items[i].entryNumber);
      }
      // const bulkDelete = dispatch(deleteBulkItemsFromCart(entryNumbers));
      const response = await Promise.all([...promiseArray, ...entryNumbers]);
      // const response = await Promise.all([...promiseArray, bulkDelete]);
      callback(response);
      // dispatch(hideLoader('cart-loader'));
      // setTimeout(() => {
      //   dispatch(showLoader('cart-loader'));
      //   dispatch(getCart({ isRequestOrginIsBrowser: true }))
      //     .then(() => {
      //       dispatch(hideLoader('cart-loader'));
      //     })
      //     .catch(() => {
      //       dispatch(hideLoader('cart-loader'));
      //     });
      // }, 20000);
    } catch (error) {
      callback(error);
    }
  };
}
